<template>
  <div class="scroll-event">
    <p>scroll event check</p>
  </div>
</template>

<script>
  export default {
    mounted() {
      // NOTE: Doorlock에서는 floating button이 없음, error 방지를 위해...
      if (this.$route.name !== 'doorlocks') {
        // 컨텐츠 내의 스크롤 이벤트가 일어날 dom
        const chComponent = document.getElementsByClassName('ch-component')[0];
        chComponent.addEventListener('scroll', () => this.scrollEvent(), false);
      }
    },
    methods: {
      /**
       * @description 리스트페이지
       */
      scrollEvent() {
        console.info('scrollEvent');
        const floatingBtn = document.getElementsByClassName('ch-floating-btn')[0];
        floatingBtn.classList.add('scroll');
        if (this.timer !== null) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          floatingBtn.classList.remove('scroll');
        }, 300);
      },
    },
  };
</script>

<style lang="scss" scoped>
.scroll-event {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/customized-components/ScrollEvent.vue